import { useParams } from "react-router-dom";
import NotesTable from "@/features/global/components/NotesTable";
import TasksTable from "@/features/global/components/TasksTable";
import { useNoteDeepLink } from "@/features/global/components/NotesTable/useNoteDeepLink";
import { useHasCapabilityBool, useCanManageTasksBool, DOMAIN, PERMISSION } from "@/hooks/useCapabilities";
import { NoteNotableValues } from "@/types";
import { FACILITY_NOTES_QUERY, type FacilityNotesQueryResponse } from "./queries";

export default function FacilityNotesPage() {
  const { facilityId } = useParams();
  const canManageFacility = useHasCapabilityBool({
    domain: DOMAIN.FACILITIES,
    permission: PERMISSION.manageFacilities
  });
  const canManageTasks = useCanManageTasksBool();
  const showTasks = canManageTasks;

  const { highlightNoteId, openNoteId, getCopyLink, setOpenNoteInUrl, tableRef } = useNoteDeepLink({
    dataReady: true
  });

  return (
    <div ref={tableRef} className="pb-6">
      <div className="pt-12" />
      <NotesTable
        variant="top-level"
        notesQuery={FACILITY_NOTES_QUERY}
        queryVariables={{ id: facilityId || "" }}
        selectConnection={(data: FacilityNotesQueryResponse | undefined) => data?.facilityNotes}
        notableTypeFilter={[NoteNotableValues.FACILITY]}
        headingTopSpacing="none"
        getCopyLink={getCopyLink}
        highlightNoteId={highlightNoteId}
        openNoteId={openNoteId}
        onOpenNoteChange={setOpenNoteInUrl}
        addNoteVariant="filled"
        noteEditing={{
          enabled: canManageFacility,
          notableId: facilityId || "",
          notableType: NoteNotableValues.FACILITY,
          refetchQueries: [FACILITY_NOTES_QUERY],
          objectType: "facility"
        }}
      />
      {showTasks && (
        <TasksTable
          referenceableId={facilityId || ""}
          referenceableType="FACILITY"
          tableHeading="Facility Tasks"
          tableBody="View and manage tasks for this facility"
          hideControls
        />
      )}
    </div>
  );
}
